module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Save Image?","confirm":"Do you want to save image for later transcription?","cancel":"Cancel","save":"Save"},"sl":{"title":"Shrani sliko?","confirmText":"Ali želite shraniti sliko za kasnejši prepis?","cancel":"Prekliči","save":"Shrani"}}')
  delete Component.options._Ctor
}
